// PrivateRoute.tsx in v6
import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import IgniteNavBar from "./IgniteNavBar";
import { isLoggedIn, getSubsite, isNhKLocked } from "../reducers/auth";
import { useSelector } from "react-redux";
import IgniteFooter from "./IgniteFooter";

const NHK_ALLOWLIST = [
  '/newhirekit',
  '/profile',
  '/logout',
];

const AuthRetailRoute = ({ children }) => {
  let navigate = useNavigate();
  const location = useLocation();
  const isLoggedInVal = useSelector(isLoggedIn);
  const currentSubsite = useSelector(getSubsite);
  const nhkLocked = useSelector(isNhKLocked);
  
  useEffect(() => {
    if (!isLoggedInVal && !currentSubsite) {
      navigate("/home");
      return;
    }
    if (nhkLocked && isLoggedInVal) {
      const path = location.pathname || '';
      const allowed = NHK_ALLOWLIST.some((p) => path === p || path.startsWith(p + '/'));
      if (!allowed) {
        navigate("/newhirekit", { replace: true });
      }
    }
  }, [currentSubsite, isLoggedInVal, navigate, nhkLocked, location.pathname]);

  return (
    <div>
      <IgniteNavBar />
      {children}
      <IgniteFooter menuBgColor={currentSubsite?.subsite_content?.menuBgColor} menuTextColor={currentSubsite?.subsite_content?.menuTextColor} menuTextHoverColor={currentSubsite?.subsite_content?.menuTextHoverColor}/>
    </div>
  ) 
};

export default AuthRetailRoute;
